export { useResolveRooms } from '@dc-shared-web/hooks/api/comments/useResolveRooms'
